import {cs}                from "@Common/react/chain-services";
import {consumeContext}    from "@Common/react/context";
import {defaultStateValue} from "@Common/react/default-state-value";
import {scopedState}       from "@Common/react/scoped-state";
import {UseState}          from "@Common/react/use-state";
import {
    changeNestedValue,
    getNestedValue,
    setNestedValue
}                          from "@Common/utils/arr-path";
import {chain}             from "@Common/utils/fs";
import {omit}              from "@Common/utils/objects";

export const MailingClassLogic = ({item, templateOptions, next: rootNext}) => cs(

    ["state", (_, next) => UseState({
        getInitValue: () => chain(
            item ? getNestedValue(item, ["selections", "distributionLevel"]) : null,
            (_) => ({
                saved: _,
                current: _,
            })
        ),
        next,
    })],
    consumeContext("mailingLists"),

    ["step1", ({}, next) => rootNext({
        cleanItem: (item) => changeNestedValue(item, ["selections"], (_) => omit(_, ["distributionLevel"])),
        next,
    })],

    ["forcedStandard", ({mailingLists, step1: {mailingListIds}}, next) => next(
        mailingLists?.value?.some((mailingList) => (
            mailingListIds?.some((mlid) => mlid == mailingList.id) && mailingList.type === "saturation"
        ))
    )],

    ["mailingClassKeys", (_, next) => next(
        Object.keys(templateOptions.mailingClasses)
    )],

    ["currentState", ({state, forcedStandard, mailingClassKeys, step1: {getDefaultMailClass}}, next) => next(defaultStateValue({
        state: scopedState(state, ["current"]),
        getDefaultValue: (v) => mailingClassKeys.includes("5") ? (
            "5"
        ) : forcedStandard ? (
            "3"
        ) : mailingClassKeys.includes(v) ? (
            v
        ) : (
            getDefaultMailClass?.() ?? mailingClassKeys[0]
        ),
    }))],

    ({step1, state, currentState, forcedStandard, mailingClassKeys}) => step1.next({
        mailingClassId: currentState.value,
        itemEditor: {
            $name: "mailing class",
            valid: true,
            changed: state.value.saved !== currentState.value,

            prepareSave: (item) => ({
                newValue: setNestedValue(item, ["selections", "distributionLevel"], currentState.value),
                onSaved: () => state.change((s) => ({
                    ...s,
                    saved: currentState.value,
                })),
            }),
        },

        ui: {
            forcedStandard,
            mailingClassKeys,
            state: currentState,
        },
    }),
);
